import { render, staticRenderFns } from "./registrationSteps.vue?vue&type=template&id=07e39230"
import script from "./registrationSteps.vue?vue&type=script&lang=js"
export * from "./registrationSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports